module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_craquen.322da656.pdf";